<template>
  <iframe width="100%" height="100%" :src="url" class="preview-iframe" />
</template>

<style scoped>
.preview-iframe {
  border: none;
}
</style>

<script>
export default {
  name: 'DocumentPreview',
  props: {
    url: String
  }
}
</script>